import React from "react";
import FlexView from "react-flexview";
import Button from "../../../modules/commons/Button";
import moment from "moment";
import SimpleDDL from "../../../modules/SimpleDDL";
import { mapToDDL } from "../../common/mapper";
import SimpleInput from "../../../modules/SimpleInput";
import { FormatCurrencyRupiah } from "../../../Services/Utils";
import { ACTIVITY_TYPE } from "../../common/Constants";

export const tableConfig = ({
  toggleEdit,
  handleDelete,
  dataTable,
  userAccess,
}) => [
  {
    name: "",
    label: "No",
    options: {
      customBodyRender: (_, tableMeta) => {
        const { page, rowsPerPage } = tableMeta.tableState;
        return page * rowsPerPage + tableMeta.rowIndex + 1;
      },
      setCellProps: () => ({
        style: { width: "5%" },
      }),
    },
  },
  {
    name: "kodeDokumen",
    label: "Kode Dokumen",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
    },
  },
  {
    name: "mainDealer",
    label: "Main Dealer",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
    },
  },
  {
    name: "tanggalBerlaku",
    label: "Tanggal Berlaku",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
    },
  },
  {
    name: "cabangBerlaku",
    label: "Cabang Berlaku",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
    },
  },
  {
    name: "servicePriceId",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const isCanEdit = userAccess?.updateAccess;
        const isCanDelete = userAccess?.deleteAccess;

        return (
          <FlexView vAlignContent="center" style={{ gap: "12px" }}>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              disabled={!isCanEdit}
              onClick={() => toggleEdit(val, ACTIVITY_TYPE.UPDATE)}
            >
              <i
                className={`fa fa-pencil-alt  ${
                  isCanEdit ? "color-red" : "color-grey"
                }`}
              />
            </Button>
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              disabled={!isCanDelete}
              onClick={() =>
                handleDelete(
                  dataTable[rowIndex]?.servicePriceId,
                  ACTIVITY_TYPE.DELETE
                )
              }
            >
              <i
                className={`fa fa-trash ${
                  isCanDelete ? "color-red" : "color-grey"
                }`}
              />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const INITIAL_DATE = moment().format("DD-MM-YYYY");

export const INITIAL_PAGINATION = {
  limit: 5,
  page: 1,
  totalData: [],
};

export const INITIAL_FILTER_VALUE = {
  kodeDokumen: null,
  startTanggalBerlaku: INITIAL_DATE,
  endTanggalBerlaku: INITIAL_DATE,
  mainDealer: null,
  cabangBerlaku: null,
  kodeJasa: null,
  namaJasa: null,
  kodeVarian: null,
  namaVarian: null,
};

export const tableConfigDetailPage = ({
  toggleEdit,
  handleDelete,
  dataTable,
  kodeJasaOptions,
  namaJasaOptions,
  handleSelectValue,
  handleSaveRow,
  errors,
  onOpenKodeJasa,
  onOpenNamaJasa
}) => [
  {
    name: "",
    label: "No",
    options: {
        customBodyRender: (value, tableMeta) => {
            return <>{tableMeta.rowIndex + 1}</>;
        },
        setCellProps: () => ({
        style: { width: "5%" },
      }),
        sort: false,
    },
  },
  {
    name: "kodeJasa",
    label: (
      <>
        Kode Jasa/Job <span style={{ color: "red" }}>*</span>
      </>
    ),
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const isSaved = dataTable[rowIndex]?.isSaved;
        if (isSaved) {
          return val;
        }
        return (
          <SimpleDDL
            errorMessage={errors?.[rowIndex]?.kodeJasa}
            showErrorWithoutMandatory
            isClearable
            id="id_dropddown_kode_jasa"
            box="search"
            containerclassname="width width-200px"
            onMenuOpen={onOpenKodeJasa}
            name="kodeJasa"
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={kodeJasaOptions}
            value={mapToDDL(val, val)}
            onChange={(value, { name }) => {
              handleSelectValue(name, value?.value, rowIndex);
              handleSelectValue("namaJasa", value?.namaJasa, rowIndex);
              handleSelectValue("kodeVarian", value?.kodeVarian, rowIndex);
              handleSelectValue("namaVarian", value?.namaVarian, rowIndex);
              handleSelectValue(
                "serviceCategory",
                value?.serviceCategory,
                rowIndex
              );
              handleSelectValue("serviceId", value?.serviceId, rowIndex);
            }}
          />
        );
      },
    },
  },
  {
    name: "namaJasa",
    label: (
      <>
        Nama Jasa/Job <span style={{ color: "red" }}>*</span>
      </>
    ),
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "20%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const isSaved = dataTable[rowIndex]?.isSaved;
        if (isSaved) {
          return val;
        }
        return (
          <SimpleDDL
            errorMessage={errors?.[rowIndex]?.namaJasa}
            showErrorWithoutMandatory
            isClearable
            id="id_dropddown_nama_jasa"
            box="search"
            containerclassname="width width-300px"
            name="namaJasa"
            onMenuOpen={onOpenNamaJasa}
            styles={{
              menu: (provided) => ({
                ...provided,
                position: "relative",
                fontFamily:
                  "FontFirst2, Helvetica Neue, Helvetica, Arial, sans-serif",
              }),
            }}
            options={namaJasaOptions}
            value={mapToDDL(val, val)}
            onChange={(value, { name }) => {
              handleSelectValue(name, value?.value, rowIndex);
              handleSelectValue("kodeJasa", value?.kodeJasa, rowIndex);
              handleSelectValue("kodeVarian", value?.kodeVarian, rowIndex);
              handleSelectValue("namaVarian", value?.namaVarian, rowIndex);
              handleSelectValue(
                "serviceCategory",
                value?.serviceCategory,
                rowIndex
              );
              handleSelectValue("serviceId", value?.serviceId, rowIndex);
            }}
          />
        );
      },
    },
  },
  {
    name: "serviceCategory",
    label: "Service Category",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
    },
  },
  {
    name: "kodeVarian",
    label: "Kode Varian",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "10%" },
      }),
    },
  },
  {
    name: "namaVarian",
    label: "Nama Varian",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
    },
  },
  {
    name: "harga",
    label: (
      <>
        Harga <span style={{ color: "red" }}>*</span>
      </>
    ),
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "30%" },
      }),
      customBodyRender: (val, { rowIndex }) => {
        const isSaved = dataTable[rowIndex]?.isSaved;
        if (isSaved) {
          return FormatCurrencyRupiah({ number: Number(val) });
        }
        return (
          <SimpleInput
            id="id_dropddown_kode_jasa"
            box="number"
            errorMessage={errors?.[rowIndex]?.harga}
            showErrorWithoutMandatory
            name="harga"
            value={val}
            containerclassname="width width-100px"
            onValueChange={({ value }) =>
              handleSelectValue("harga", value, rowIndex)
            }
          />
        );
      },
    },
  },
  {
    name: "aksi",
    label: "Aksi",
    options: {
      sort: false,
      setCellProps: () => ({
        style: { width: "15%" },
      }),
      customBodyRender: (_, { rowIndex }) => {
        const isSaved = dataTable[rowIndex]?.isSaved;

        return (
          <FlexView vAlignContent="center" style={{ gap: "12px" }}>
            {isSaved ? (
              <Button
                className="btnAct background-transparent txt-site txt-title"
                type="button"
                onClick={() => toggleEdit(rowIndex)}
              >
                <i className={`fa fa-pencil-alt color-red`} />
              </Button>
            ) : (
              <Button
                className="btnAct background-transparent txt-site txt-title"
                type="button"
                onClick={() => handleSaveRow(rowIndex)}
              >
                <i className={`fa fa-save color-red`} />
              </Button>
            )}
            <Button
              className="btnAct background-transparent txt-site txt-title"
              type="button"
              onClick={() => handleDelete(rowIndex)}
            >
              <i className={`fa fa-times-circle color-red`} />
            </Button>
          </FlexView>
        );
      },
    },
  },
];

export const INITIAL_VALUE_TABLE_DETAIL = {
  kodeJasa: null,
  namaJasa: null,
  serviceCategory: null,
  kodeVarian: null,
  namaVarian: null,
  harga: null,
  isSaved: false,
};
